/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import reducerPath from '../../../../app/reducerPath';

// Инициализация стейта в сторе
export const initialState = {};

// Создание слайса тут пишем инициализированный стейт и редюсеры
export const socketLogisticTasksSlice = createSlice({
  name: reducerPath.stateLogisticTasksResource,
  initialState,
  reducers: {
    setData(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    reset() {
      return initialState;
    },
  },
});

export const stateLogisticTasksResourceActions = socketLogisticTasksSlice.actions;
export const stateLogisticTasksResourceReducer = socketLogisticTasksSlice.reducer;
